import { useEffect, useRef } from 'react';
import Button from '../../UI/Button';
import { GOOGLE_CLIENT_ID } from '../../../constants';

export const GoogleButton = ({ onSuccess, onError, children }) => {
  const googleBtnRef = useRef(null);

  const handleLogin = () => {
    window.google.accounts.id.initialize({
      client_id: GOOGLE_CLIENT_ID,
      callback: onSuccess,
    });

    window.google.accounts.id.renderButton(
      googleBtnRef.current,
      { type: "standard", theme: "outline", size: "large" }
    );

    googleBtnRef.current.querySelector('div[role="button"]').click();
  }

  return (
    <>
      <Button google onClick={handleLogin}>{children}</Button>
      <div style={{ display: 'none' }} ref={googleBtnRef} />
    </>
  );
};
